var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { staticClass: "ma-1", attrs: { cols: "12" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-text", { staticClass: "pa-6" }, [
            _vm._v(
              "\n            This is placeholder content for an accounts hub page, which will link to all relevant accounts pages from one place\n        "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }